import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import {
  ADD_QUESTION,
  DELETE_QUESTION,
  GET_ALL_BRANCH_RATINGS,
  GET_ALL_QUESTIONS,
  GET_ALL_RATINGS,
  GET_BRANCH_RATINGS_DETAILS,
  GET_QUESTION_DETAILS,
  UPDATE_QUESTION,
  UPDATE_QUESTION_STATUS,
} from "helpers/url_helper"

export const getAllRatings = createAsyncThunk(
  GET_ALL_RATINGS,
  async payload => {
    const response = await post(GET_ALL_RATINGS, payload)
    return response
  }
)

export const getAllRatingQuestions = createAsyncThunk(
  GET_ALL_QUESTIONS,
  async payload => {
    const response = await post(GET_ALL_QUESTIONS, payload)
    return response
  }
)

export const updateQuestionStatus = createAsyncThunk(
  UPDATE_QUESTION_STATUS,
  async payload => {
    const response = await patch(UPDATE_QUESTION_STATUS, payload)
    return response
  }
)

export const deleteQuestion = createAsyncThunk(
  DELETE_QUESTION,
  async payload => {
    const response = await del(`${DELETE_QUESTION}`, payload)
    return response
  }
)

export const addQuestion = createAsyncThunk(ADD_QUESTION, async payload => {
  const response = await post(ADD_QUESTION, payload)
  return response
})

export const getQuestionDetails = createAsyncThunk(
  GET_QUESTION_DETAILS,
  async id => {
    const response = await get(`${GET_QUESTION_DETAILS}/${id}`)
    return response
  }
)

export const updateQuestion = createAsyncThunk(
  UPDATE_QUESTION,
  async payload => {
    const response = await put(UPDATE_QUESTION, payload)
    return response
  }
)

export const getAllBranchRatings = createAsyncThunk(
  GET_ALL_BRANCH_RATINGS,
  async payload => {
    const response = await post(GET_ALL_BRANCH_RATINGS, payload)
    return response
  }
)

export const getBranchRatingDetails = createAsyncThunk(
  GET_BRANCH_RATINGS_DETAILS,
  async id => {
    const response = await get(`${GET_BRANCH_RATINGS_DETAILS}/${id}`)
    return response
  }
)
